import Axios from "axios"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

export const logoutUser = async () => {
  try {
    await Axios.get("/api/auth/logout")
  } catch (error) {
    return error
  }
}

export const login = async user => {
  try {
    const response = await Axios.post("/api/auth/login", user)
    return response
  } catch (error) {
    return error
  }
}

export const googlelogin = async (user, isInternalDomain) => {
  try {
    const response = await Axios.post(
      "/api/auth/googlelogin",
      user,
      isInternalDomain
    )
    return response.data
  } catch (error) {
    return error
  }
}

export const getClientId = async () => {
  try {
    const response = await Axios.get("/api/auth/getClientId")
    return response.data
  } catch (error) {
    return error
  }
}

export const sendEmailOTP = async (mobileNo, email) => {
  try {
    const response = await Axios.post("/api/auth/otp/sendEmailOTP", {
      mobileNo,
      email,
    })
    return response.data
  } catch (error) {
    return error
  }
}

export const sendOTP = async mobileNo => {
  try {
    const response = await Axios.post("/api/auth/otp/send", { mobileNo })
    return response.data
  } catch (error) {
    return error
  }
}

export const verifyOTP = async (mobileNo, otp) => {
  try {
    const response = await Axios.post("/api/auth/otp/verify", { mobileNo, otp })
    return response.data
  } catch (error) {
    return error
  }
}
export const forgetPassword = async email => {
  try {
    const response = await Axios.post("/api/auth/requestResetPassword", email)
    return response
  } catch (error) {
    return error
  }
}

export const changePassword = async details => {
  try {
    const response = await Axios.post("/api/auth/changepassword", details)
    toastr.success("Password Changed Successfully !!")
    return response
  } catch (error) {
    return error
  }
}
